import { query } from '@confluence/query-preloader-tools';

import type {
	ContentPrerequisitesQuery as QP,
	ContentPrerequisitesQueryVariables as VP,
} from './__types__/ContentPrerequisitesQuery';
import { ContentPrerequisitesQuery } from './ContentPrerequisitesQuery.graphql';
import type {
	ContentRedirectQuery as QR,
	ContentRedirectQueryVariables as VR,
} from './__types__/ContentRedirectQuery';
import { ContentRedirectQuery } from './ContentRedirectQuery.graphql';

const preloadContentPrerequisitesQuery = (
	contentId: string,
	spaceKey: string | null | undefined,
	includeAlias: boolean,
) =>
	query<QP, VP>({
		query: ContentPrerequisitesQuery,
		errorPolicy: 'all',
		variables: {
			contentId,
			missingSpaceKey: !spaceKey,
			spaceKey,
			includeAlias,
		},
	});

const preloadContentRedirectQuery = ({
	contentId,
	includeAlias,
	versionOverride,
}: PreloadContentRedirectQueryArgs) =>
	query<QR, VR>({
		query: ContentRedirectQuery,
		errorPolicy: 'all',
		variables: {
			contentId,
			includeAlias,
			versionOverride,
		},
	});

type PreloadContentRedirectQueryArgs = {
	contentId: string;
	includeAlias: boolean;
} & Pick<PreloadContentPrerequisitesNamedArgs, 'versionOverride'>;

export const preloadContentPrerequisites = (
	contentId: string,
	spaceKey: string | null | undefined,
	includeAlias: boolean,
	// Note: Add new function parameters/arguments to namedArgs below please! More than 3-4 unnamed function arguments makes it noticeably harder to comprehend the function calls.
	namedArgs?: PreloadContentPrerequisitesNamedArgs,
) =>
	Promise.all([
		preloadContentPrerequisitesQuery(contentId, spaceKey, includeAlias),
		preloadContentRedirectQuery({ contentId, includeAlias, ...namedArgs }),
	]);

type PreloadContentPrerequisitesNamedArgs = {
	versionOverride?: number | null;
};
